import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InternationalStudentsComponent } from './international-students.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: InternationalStudentsComponent,
    data: {
      title: "International Students",
      breadcrumb: "International Students"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class InternationalStudentsRoutingModule { }